import * as update from "immutability-helper";
import * as moment from "moment";
import * as DTOS from "../FeralScan.dtos";
import { APPLY_FILTER, FilterAction, SET_SHOW_FILTERS_REQUEST } from "../actions/filter.actions";
import { LOGOUT_SUCCESS } from "../actions/login.actions";
import * as Configuration from '../configuration';
import { IClassificationSelectOption } from "../components/Common/ClassificationSelect";


export type FilterState = {
    startDate: any,
    endDate: any,
    defaultDateSpan: number,
    defaultGraph: string,
    selectedRegion: DTOS.QuestionOption[],
    selectedTypes: DTOS.QuestionOption[],
    selectedQuestions: DTOS.QuestionOption[],
    selectedClassifications: IClassificationSelectOption,
    selectedGroups: DTOS.QuestionOption[],
    selectedDateRange: any,
    selectedState: any

    selectedDataView: string,

    showFilters: boolean,
    showAdvancedFilter: boolean,
    showSaveFilterModal: boolean,

}

const initialState: FilterState = {
    startDate: moment().local().add(-1 * Configuration.custom.defaultFilterDays, 'days').startOf('day'),
    endDate: moment().local().endOf('day'),
    defaultDateSpan: Configuration.custom.defaultFilterDays,
    defaultGraph: "total",
    selectedRegion: [],
    selectedTypes: [],
    selectedQuestions: [],
    selectedClassifications: undefined,
    selectedState: null,
    selectedDateRange: {
        // @TODO: currently hardcoded default to all data 
        dateStartDifference: -10000,
        optionId: 0,
        type: "DATE_RANGE",
        value: "100000",
        label: "All data",
        rank: 0
    },
    selectedGroups: [],

    showAdvancedFilter: false,
    showSaveFilterModal: false,
    showFilters: false,

    selectedDataView: 'alldata'
}

export default function filter(state: FilterState = initialState, action: FilterAction) {
    switch (action.type) {
        case SET_SHOW_FILTERS_REQUEST:
            return showFilters(state, action.showFilters);

        case APPLY_FILTER:
            return updateFilters(state, action);

        case LOGOUT_SUCCESS:
            return clearFilters(state);
    }
    return state;
}

function showFilters(state: FilterState, showFilters: boolean) {
    let newState = update(state, {
        showFilters: { $set: showFilters }
    });
    return newState;
}

function clearFilters(state: FilterState) {
    return update(state, { $set: initialState });
}

function updateFilters(state: FilterState, action: FilterAction) {
    return update(state, { $set: action.filters });
}
